<template>
  <div></div>
</template>
<script>
export default {
  mounted() {
    const deepLinkValue = this.$route.params.data.split("data=")[1];

    if (deepLinkValue) {
      sessionStorage.setItem("deepLink", deepLinkValue);
    }

    window.location.href = `${window.location.origin}${window.location.search}`;
  },
};
</script>
